module.exports = require("@deck.gl/core");